/*
 * Copyright (c) 2018 Network International.
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import uniq from 'lodash/uniq';
import Text, { TextTypes } from 'ni-ui/text';
import COLORS from 'ni-ui/colors';
import { Col } from 'ni-ui/layout';
import CardLogo from './card-logo';
import styles from './styles.scss';
import cardLogo from '../../../images/card.svg';

const CardHeader = ({ allowedCardTypes, cardHeaderTitle }) => (
  <div className={styles.headerContainer}>
    <Col gutter={false} span={4} sm={7} md={4}>
      <div className={styles.holder}>
        <img src={cardLogo} alt="Cards" />
        <Text textKey={cardHeaderTitle || 'PAY_BY_CARD'} textColor={COLORS.GREY_VERY_DARK} type={TextTypes.MENU_LEVEL_2} />
      </div>
    </Col>
    <Col gutter={false}>
      <div className={styles.cardsHolder}>
        {uniq((allowedCardTypes || []))
          .map(cardType => <CardLogo key={cardType} cardType={cardType} />)}
      </div>
    </Col>
  </div>
);

CardHeader.propTypes = {
  allowedCardTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  cardHeaderTitle: PropTypes.string,
};

CardHeader.defaultProps = {
  cardHeaderTitle: '',
};

export default CardHeader;
